import { Apple, Play } from "lucide-react";
import Reveal from "@/components/ui/reveal";
import WaitlistForm from "./WaitlistForm";

const QR = (data) =>
    `https://api.qrserver.com/v1/create-qr-code/?size=160x160&margin=0&color=2E4F42&data=${encodeURIComponent(data)}`;

export default function DownloadHub() {
    return (
        <section id="download" className="py-20 lg:py-28">
            <div className="container-gr">
                <Reveal className="overflow-hidden rounded-3xl border border-border bg-card">
                    <div className="grid gap-10 p-8 sm:p-12 lg:grid-cols-2">
                        <div>
                            <p className="font-mono text-xs uppercase tracking-[0.2em] text-gr-accent">Pobierz</p>
                            <h2 className="mt-3 text-3xl tracking-tight text-foreground sm:text-4xl">Miej księgowość w kieszeni</h2>
                            <p className="mt-4 text-muted-foreground">Zeskanuj kod telefonem albo pobierz ze sklepu. Premiera już wkrótce.</p>

                            <div className="mt-8 flex flex-wrap gap-6">
                                <div className="text-center" data-testid="qr-appstore">
                                    <div className="rounded-2xl border border-border bg-white p-3">
                                        <img src={QR("https://groszownik.io/download#ios")} alt="Kod QR — App Store" width="160" height="160" loading="lazy" />
                                    </div>
                                    <p className="mt-2 text-xs font-medium text-muted-foreground">iOS · App Store</p>
                                </div>
                                <div className="text-center" data-testid="qr-googleplay">
                                    <div className="rounded-2xl border border-border bg-white p-3">
                                        <img src={QR("https://groszownik.io/download#android")} alt="Kod QR — Google Play" width="160" height="160" loading="lazy" />
                                    </div>
                                    <p className="mt-2 text-xs font-medium text-muted-foreground">Android · Google Play</p>
                                </div>
                            </div>

                            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
                                <a href="#" data-testid="download-appstore" className="flex items-center gap-3 rounded-2xl bg-gr-ink px-5 py-3 text-white transition-transform hover:-translate-y-0.5 active:scale-95 dark:bg-white dark:text-gr-ink">
                                    <Apple className="h-6 w-6" />
                                    <span className="text-left leading-none"><span className="block text-[10px] opacity-70">Pobierz z</span><span className="block font-heading text-base font-bold">App Store</span></span>
                                </a>
                                <a href="#" data-testid="download-googleplay" className="flex items-center gap-3 rounded-2xl bg-gr-ink px-5 py-3 text-white transition-transform hover:-translate-y-0.5 active:scale-95 dark:bg-white dark:text-gr-ink">
                                    <Play className="h-6 w-6" />
                                    <span className="text-left leading-none"><span className="block text-[10px] opacity-70">Dostępne w</span><span className="block font-heading text-base font-bold">Google Play</span></span>
                                </a>
                            </div>
                        </div>

                        <div className="rounded-2xl bg-gr-surface2 p-6 dark:bg-gr-dsurface2 sm:p-8">
                            <h3 className="font-heading text-xl font-extrabold text-foreground">Nie chcesz przegapić premiery?</h3>
                            <p className="mt-2 text-sm text-muted-foreground">Zapisz się na listę oczekujących — pierwsi dostaną dostęp i bonus PRO.</p>
                            <div className="mt-6">
                                <WaitlistForm source="download-hub" />
                            </div>
                        </div>
                    </div>
                </Reveal>
            </div>
        </section>
    );
}
